import { KshowTheme } from "../.internal/themes/KshowTheme";
export default KshowTheme;